export function triggerBodyClass(className, state) {
  if (window) {
    var bodyClassName = document.body.className;
    if (state) {
      if (!bodyClassName.includes(className)) {
        document.body.className += " ".concat(className);
      }
    } else {
      document.body.className = document.body.className.replace("".concat(className), '').trim();
    }
  }
}